import { GraphQLQuery } from '@aws-amplify/api';
import { notifyError } from "../../../../components/ServiceNotifications";
import {
    Customer,
    CreateCustomerInput,
    CreateCustomerResponse,
    UpdateCustomerInput,
    UpdateCustomerResponse,
    GetCustomerResponse
} from '../types';
import { getCustomerQuery } from './queries';
import { createCustomerMutation, updateCustomerMutation } from './mutations';
import { billingClient } from '../../billing-api-integration/client';

export type { Customer, CreateCustomerInput, UpdateCustomerInput } from '../types';

export const createCustomer = async (input: CreateCustomerInput): Promise<Customer | undefined> => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<CreateCustomerResponse>>({
            query: createCustomerMutation,
            variables: { input },
        });
        
        console.log('Customer created:', response.data?.createCustomer);
        return response.data?.createCustomer;
    } catch (e: any) {
        console.error('Error creating customer:', e);
        console.error('Customer creation payload:', { ...input, status: 'Active' });
        if (e.errors) {
            console.error('GraphQL errors:', e.errors);
        }
        notifyError(e);
    }
};

export const fetchCustomer = async (id: string): Promise<Customer | undefined> => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<GetCustomerResponse>>({
            query: getCustomerQuery,
            variables: { id },
        });
        
        return response.data?.getCustomer;
    } catch (e: any) {
        console.error('Error fetching customer:', e);
        console.error('Customer fetch ID:', id);
        if (e.errors) {
            console.error('GraphQL errors:', e.errors);
        }
        notifyError(e);
    }
};

export const updateCustomer = async (id: string, input: Partial<UpdateCustomerInput>): Promise<Customer | undefined> => {
    try {
        const updateInput: UpdateCustomerInput = {
            id,
            ...input
        };
        
        const response = await billingClient.graphql<GraphQLQuery<UpdateCustomerResponse>>({
            query: updateCustomerMutation,
            variables: { input: updateInput },
        });
        
        console.log('Customer updated:', response.data?.updateCustomer);
        return response.data?.updateCustomer;
    } catch (e: any) {
        console.error('Error updating customer:', e);
        console.error('Customer update payload:', { id, ...input });
        if (e.errors) {
            console.error('GraphQL errors:', e.errors);
        }
        notifyError(e);
    }
};

export const createCustomerFromUser = async (user: any): Promise<Customer | undefined> => {
    const customerPayload: CreateCustomerInput = {
        name: `${user.given_name || ''} ${user.family_name || ''}`.trim(),
        status: 'ACTIVE',  // Must be uppercase per GraphQL schema
        contactInfo: {
            email: user.email,
        },
    };
    
    return await createCustomer(customerPayload);
};


